/**
 * Fraire mobile sticky add-to-cart
 */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const initStickyAtc = () => {
    document.querySelectorAll('[id^="FraireStickyAtc-"]').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';

      const sectionId = bar.dataset.sectionId;
      const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const stickyButton = document.getElementById(`FraireStickySubmit-${sectionId}`);
      const productForm = document.getElementById(`product-form-${sectionId}`);

      if (!mainButton || !stickyButton || !productForm) return;

      stickyButton.addEventListener('click', () => {
        if (!mainButton.disabled) mainButton.click();
      });

      const toggleBar = (show) => {
        if (show) {
          bar.removeAttribute('hidden');
          document.body.classList.add('fraire-sticky-atc-visible');
        } else {
          bar.setAttribute('hidden', '');
          document.body.classList.remove('fraire-sticky-atc-visible');
        }
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => toggleBar(!entry.isIntersecting),
          { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
        );
        observer.observe(mainButton);
      }

      const syncFromMain = () => {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.querySelector('span').textContent = mainButton.querySelector('span')?.textContent || '';
      };

      syncFromMain();
      new MutationObserver(syncFromMain).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data || String(event.data.sectionId) !== String(sectionId)) return;

          const priceEl = document.getElementById(`FraireStickyPrice-${sectionId}`);
          const newPrice = event.data.html?.getElementById(`price-${sectionId}`);
          if (priceEl && newPrice) priceEl.innerHTML = newPrice.innerHTML;

          const newButton = event.data.html?.getElementById(`ProductSubmitButton-${sectionId}`);
          if (newButton) {
            stickyButton.disabled = newButton.disabled;
            const label = newButton.querySelector('span');
            if (label) stickyButton.querySelector('span').textContent = label.textContent;
          }
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();
